







































import Vue from 'vue'
import PrintTag from '@/common/components/PrintTag.vue'
import BaseImage from '@/common/components/BaseImage.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { TopProductItem } from '@/top/types'
import { formatOneDecimal } from '@/common/utils/common'

export default Vue.extend({
  name: 'ProductCard',
  components: {
    BaseImage,
    PrintTag
  },
  props: {
    productItem: {
      type: Object as () => TopProductItem,
      required: true
    }
  },
  computed: {
     placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE_CARD
    },
    productUrl(): string {
      return `products/${this.productItem.id}`
    }
  },
  methods: {
    formatOneDecimal
  }
})
